module.exports = __webpack_public_path__ + "img/PID.1d39918c.png";